// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"3011e888","333":"361b7af3","453":"41f208de","479":"3e19ca0b"}[chunkId] + ".chunk.js";
};